import { render, staticRenderFns } from "./UsersTableData.vue?vue&type=template&id=019d73e0&scoped=true&"
import script from "./UsersTableData.vue?vue&type=script&lang=js&"
export * from "./UsersTableData.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableData.vue?vue&type=style&index=0&id=019d73e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d73e0",
  null
  
)

export default component.exports